/** Compatibility wrapper — prefer `@/lib/api` for new code. */
import { api, get, post, put, del } from "./api";

type FetchOptions = RequestInit & {
  skipAuth?: boolean;
};

export async function apiFetch<T = unknown>(url: string, options?: FetchOptions): Promise<T> {
  const method = (options?.method || "GET").toUpperCase();
  let body: unknown;
  if (options?.body) {
    body = typeof options.body === "string" ? JSON.parse(options.body) : options.body;
  }

  const headers: Record<string, string> = {};
  if (options?.headers) {
    const h = new Headers(options.headers);
    h.forEach((value, key) => {
      headers[key] = value;
    });
  }

  return api<T>(url, {
    method,
    body,
    headers,
    skipAuth: options?.skipAuth,
  });
}

apiFetch.get = <T = unknown>(url: string, options?: FetchOptions) =>
  apiFetch<T>(url, { ...options, method: "GET" });

apiFetch.post = <T = unknown>(url: string, body: unknown, options?: FetchOptions) =>
  apiFetch<T>(url, { ...options, method: "POST", body: JSON.stringify(body) });

apiFetch.put = <T = unknown>(url: string, body: unknown, options?: FetchOptions) =>
  apiFetch<T>(url, { ...options, method: "PUT", body: JSON.stringify(body) });

apiFetch.patch = <T = unknown>(url: string, body: unknown, options?: FetchOptions) =>
  apiFetch<T>(url, { ...options, method: "PATCH", body: JSON.stringify(body) });

apiFetch.delete = <T = unknown>(url: string, options?: FetchOptions) =>
  apiFetch<T>(url, { ...options, method: "DELETE" });

export { get, post, put, del };
